export const skyBlueLighter = "#F1F7FE";
export const skyBlueLight = "#DAEBFF";
export const skyBlue = "#C1DEFF";

export const blueLight = "#0073E5";
export const blue = "#006FE8";
export const blueDark = "#0064CF";
// export const blueDark = "#0051A8";

export const graphiteLight = "#001C3A";
export const graphite = "#001933";
export const graphiteDark = "#001124";

export const tooltipBlack = "#333333";

export const redLighter = "#FDD8D9";
export const redLight = "#FF4545";
export const red = "#E63E3E";
export const redDark = "#BF3434";

export const bitcoinOrange = "#FF9900";
export const orangeLight = "#FFB74D";
export const orange = "#FF9800";
export const orangeDark = "#F57C00";

export const bitcoinCashGreen = "#6CC64B";
export const greenLight = "#3CBC98";
export const green = "#34A384";
export const greenDark = "#2C8A6F";

export const textDark = "#3F3F48";
export const textLight = "#6B6D70";
export const textLighter = "#737478";
export const textDisabled = "#DCE0E3";

export const grayDisabled = "#c1c2c4";
export const grayLight = "#EBEDF2";
export const gray = "#D2D4D9";
export const grayDark = "#D2D4D9";
export const grayPlaceholder = "#D0D2D9";
export const greyHeaderBackground = "#FBFBFC";

export const backgroundDefault = "#FBFBFB";
export const backgroundWhite = "#FFFFFF";
export const backgroundAlternative = "#FDFDFE";

export const white = "#FFFFFF";
export const whiteDarker = "#FDFDFD";
export const black = "#001B3A";

export const strokeDefault = "#DBE0E8";

export const alertWarning = "#AD5700";
export const alertWarningBackground = "#FBF3E9";

export const alertInfo = "#5027E2";
export const alertInfoBackground = "#f7f3ff";
export const alertError = "#D60000";
export const alertErrorBackground = "#FBE8E8";

export const alertSuccess = "#1E4620";
export const alertSuccessBackground = "#EDF7EA";

export const popoverBackground = "#CCE2FA";
export const popoverTextColor = graphiteLight;

export const chipPending = "#E8F3FF";
export const chipDone = "#6BFFB8";
export const chipAdvanced = "#FFD2D5";
